import { atom } from 'recoil';

export const orderPayload = atom({
    key: 'aws-av-orderPayload',
    default: {
        appProfile: null,
        appProfileDetails: null,
        appName: null,
        applicationName: null,
        appShortName: null,
        applicationName1: null,
        appShortName1: null,
        awsSector: null,
        awsSectorDetails: null,
        sector: 'CGF',
        department: null,
        appRegion: null,
        landingZoneDetails: null,
        businessCategory: null,
        region: 'us-east-1',
        environments: [],
        awsEnvironment: null,
        awsAccountName: null,
        awsOrgUnit: null,
        awsOrgUnitDetails: null,
        hCode: null,
        onPremHCode: null,
        onPremHCodeDetails: null,
        additionalInfo: null,
        businessAppDetails: null,
        businessApp: null,
        businessSponsor: null,
        businessSponsorDetails: null,
        dataClassification: null,
        entityDetails: null,
        awsCloudOnboardingOrderId: null,

        // Resource Setion
        cloudType: null,
        isaNumber: null,
        onboardingCategory: null,
        // csaApprovedArch: 'no',
        tacRequest: null,
        prevCloudOnboardReq: null,
        csa: null,
        csaDetails: null,
        nonPrivilegedADGroupList: [{ readerValue: '' }],
        privilegedADGroupList: [{ contributorValue: '' }],
        privilegedADGroup: null,
        nonPrivilegedADGroup: null,
        privilegedADGroupOwner: null,
        privilegedADGroupOwnerDetails: null,
        nonPrivilegedADGroupOwner: null,
        nonPrivilegedADGroupOwnerDetails: null,
        deletedFiles: [],
        isChinaRegion: 'no',
        adGroup: null,

        // New fields for enhanced form
        accountType: null, // 'custom' or 'network'
        hasApplicationService: null, // 'yes' or 'no'
        hasDepartment: null, // 'yes' or 'no'
        requirePrivilegedADGroup: null, // 'yes' or 'no' - not mandatory
        sharedNetworkAcct: null, // Shared Network Account Name
        tags: {}, // Tags section data

        estimatedCost: {
            details: [],
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'There is no cost for this Cloud onboarding request, however there will be cost involved based on the service Name defined at the Resource Group level for your resources that being provisioned in future.',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const urlParams = atom({
    key: 'aws-av-urlParams',
    default: {
        journeyId: null,
        appRegistrationId: null,
    },
});

export const isValidApplicationName = atom({
    key: 'aws-av-validApplicationName',
    default: false,
});
export const isAppNameValid = atom({
    key: 'aws-av-isAppNameValid',
    default: true,
});
export const isAppNameValid1 = atom({
    key: 'aws-av-isAppNameValid1',
    default: true,
});

export const isAppShortNameValid = atom({
    key: 'aws-av-isAppShortNameValid',
    default: false,
});
export const isAppShortNameExist = atom({
    key: 'aws-av-isAppShortNameExist',
    default: false,
});

export const isValidISANumber = atom({
    key: 'aws-av-isValidISANumber',
    default: false,
});

export const isValidOwners = atom({
    key: 'aws-av-isValidOwners',
    default: {
        isvalidAppOwner: true,
        isvalidCertificateOwner1: true,
        isvalidCertificateOwner2: true,
    },
});

export const toggleSspModels = atom({
    key: 'aws-av-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isNonPrivilegedADGroupOpen: false,
        isPrivilegedADGroupOpen: false,
        isADGroupModalOpen: false,
    },
});

export const costEstimateState = atom({
    key: 'aws-av-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'aws-av-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const orderId = atom({
    key: 'aws-av-orderId',
    default: '',
});

export const isNonPrivilegedADGroupValid = atom({
    key: 'aws-av-isNonPrivilegedADGroupValid',
    default: false,
});

export const isPrivilegedADGroupValid = atom({
    key: 'aws-av-isPrivilegedADGroupValid',
    default: false,
});

export const SecondaryApprover = atom({
    key: 'aws-av-secondaryApprover',
    default: { selectedFieldFrom: { module: null, subModule: null }, value: { groupOwner: null, groupOwnerDetails: null } },
});

export const uploadedFilesState = atom({
    key: 'aws-av-uploadedFilesState',
    default: [],
});

export const isAwsCloudOnboardingOrderIdValid = atom({
    key: 'aws-av-isAwsCloudOnboardingOrderIdValid',
    default: false,
});

export const showPreviewOrder = atom({
    key: 'aws-av-showPreviewOrder',
    default: null, // null, 'pre-preview-order', 'preview-order'
});

export const previewOrderError = atom({
    key: 'aws-av-previewOrderError',
    default: {
        isPreviewError: false,
        message: '',
    },
});

export const previewDetails = atom({
    key: 'aws-av-previewDetails',
    default: null,
});

export const previewApiLoading = atom({
    key: 'aws-av-previewApiLoading',
    default: false,
});

export const isHCodeValid = atom({
    key: 'aws-av-isHCodeValid',
    default: true,
});
